"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _capitalize = _interopRequireDefault(require("../capitalize"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultOptions = {
  format: 'DD MMM',
  locale: 'es',
  capitalize: true
};

/**
 * Retrieves the formatted day component of a given date based on the specified options.
 *
 * @param {Time} date - The date to retrieve days from.
 * @param {DayOptions} [options={}] - Options for configuring the day format.
 * @returns {string} - The formatted day string (e.g., "12 Sept", "13 Tue").
 *
 * @example
 * const day1 = getDay(new Date(), { format: 'DD MMM', locale: 'en' }) // e.g., "12 Sept"
 * const day2 = getDay(new Date(), { format: 'DD EEE', locale: 'es' }) // e.g., "12 lun"
 */
function getDay(date) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    format,
    locale,
    capitalize: shouldCapitalize
  } = _objectSpread(_objectSpread({}, defaultOptions), options);
  const day = date.getDate().toString().padStart(2, '0');
  let month = date.toLocaleString(locale, {
    month: 'short'
  });
  let weekday = date.toLocaleString(locale, {
    weekday: 'short'
  });
  if (shouldCapitalize) {
    month = (0, _capitalize.default)(month);
    weekday = (0, _capitalize.default)(weekday);
  }
  if (format === 'DD MMM') {
    return "".concat(day, " ").concat(month);
  } else if (format === 'DD EEE') {
    return "".concat(day, " ").concat(weekday);
  }
  throw new Error("Unsupported format: ".concat(format));
}
var _default = exports.default = getDay;